import React from 'react';
import styled from 'styled-components';

import DesktopDropdownGroup from './DesktopDropdownGroup';
import DesktopDropdownLink from './DesktopDropdownLink';
import DesktopLinkGroup from './DesktopLinkGroup';

const DesktopMenu = (props) => {
  const { mode } = props;
  return (
    <Wrapper>
      <DesktopLinkGroup label="Solutions" to="/solutions" mode={mode}>
        <DesktopDropdownGroup>
          <DesktopDropdownLink to="/solutions/pos" label="Point of Sale" />
          <DesktopDropdownLink
            to="/solutions/club"
            label="Clubs &amp; Subscriptions"
          />
          <DesktopDropdownLink to="/solutions/ecommerce" label="Ecommerce" />
          <DesktopDropdownLink to="/solutions/crm" label="CRM" />
          <DesktopDropdownLink
            to="/solutions/reservations"
            label="Reservations"
          />
          <DesktopDropdownLink to="/solutions/payments" label="Payments" />
        </DesktopDropdownGroup>
      </DesktopLinkGroup>
      <DesktopLinkGroup label="Customers" to="/customers" mode={mode}>
        <DesktopDropdownGroup label="By Region">
          <DesktopDropdownLink
            to="/customers/united-states/pacific-northwest"
            label="United States"
          />
          <DesktopDropdownLink to="/customers/canada/niagara" label="Canada" />
          <DesktopDropdownLink
            to="/customers/australia-and-new-zealand/australia"
            label="Australia / New Zealand"
          />
          <DesktopDropdownLink
            to="/customers/south-africa"
            label="South Africa"
          />
          <DesktopDropdownLink to="/customers/europe" label="Europe" />
        </DesktopDropdownGroup>
        <DesktopDropdownGroup label="By Size">
          <DesktopDropdownLink to="/customers/small" label="Small" />
          <DesktopDropdownLink to="/customers/midsize" label="Midsize" />
          <DesktopDropdownLink to="/customers/enterprise" label="Enterprise" />
        </DesktopDropdownGroup>
      </DesktopLinkGroup>
      <DesktopLinkGroup label="Partners" to="/partners" mode={mode}>
        <DesktopDropdownGroup>
          <DesktopDropdownLink to="/partners/apps" label="App Store" />
          <DesktopDropdownLink
            to="/partners/designers"
            label="Find a Design Partner"
          />
          <DesktopDropdownLink
            to="/partners/become-a-partner"
            label="Become a Partner"
          />
          <DesktopDropdownLink
            href="https://design-docs.commerce7.com/docs"
            label="Designer Docs"
          />
          <DesktopDropdownLink
            href="https://developer.commerce7.com/docs"
            label="Developer Docs"
          />
        </DesktopDropdownGroup>
      </DesktopLinkGroup>
      <DesktopLinkGroup to="/pricing" label="Pricing" mode={mode}>
        <DesktopDropdownGroup>
          <DesktopDropdownLink to="/pricing" label="Plans &amp; Pricing" />
          <DesktopDropdownLink to="/pricing/templates" label="Templates" />
        </DesktopDropdownGroup>
      </DesktopLinkGroup>
      <DesktopLinkGroup label="Resources" to="/resources" mode={mode}>
        <DesktopDropdownGroup>
          <DesktopDropdownLink to="/blog" label="Blog" />
          <DesktopDropdownLink to="/article" label="Articles" />
          <DesktopDropdownLink
            href="https://documentation.commerce7.com"
            label="Documentation"
          />
          <DesktopDropdownLink
            href="https://commerce7academy.commerce7.com/"
            label="Commerce7 Academy"
          />
          <DesktopDropdownLink
            href="https://vimeo.com/showcase/c7videohub"
            label="Video Hub"
          />
        </DesktopDropdownGroup>
      </DesktopLinkGroup>
      <DesktopLinkGroup to="/contact" label="Contact Us" mode={mode} />
    </Wrapper>
  );
};

const Wrapper = styled.nav`
  display: none;

  ${({ theme }) => `
    @media ${theme.xLargeUp} {
      display: flex;
      justify-content: center;
      align-items: center;
    }
  `}
`;

export default DesktopMenu;
